var RADIO = 'radios';
var H1 = 'h1';
var H2 = 'h2';
var H3 = 'h3';
var H4 = 'h4';

var TEXTAREA = 'textarea';
var DATE = 'input-date';
var NUMBER = 'input-number';
var TEXT = 'input';
var CHECKBOXES = 'checkboxes';
var CHECKBOX = 'checkbox';
var ACTIONS = 'actions';
var FILE_MULTIPLE = 'file-multiple';
var RICH_TEXT = 'rich-text';
var SELECT = 'select';
var TABLE_EDITABLE = 'table-editable';
var LINK = 'link';
var LOCATION = 'location';
var PARAGRAPH = 'paragraph';
var MASK = 'mask';
var INPUT_CPF = 'input-cpf';
var INPUT_CNPJ = 'input-cnpj';
var INPUT_DECIMAL = 'input-decimal';

export var alloweds = [TEXT, NUMBER, DATE, TEXTAREA, H1, H2, H3, H4, RADIO, CHECKBOX, CHECKBOXES, FILE_MULTIPLE, RICH_TEXT, SELECT, TABLE_EDITABLE, LINK, LOCATION, PARAGRAPH, MASK, INPUT_CPF, INPUT_CNPJ, INPUT_DECIMAL];

var typesWithoutLabel = [].concat(alloweds);
export var isTypeHasntLabel = function isTypeHasntLabel(fieldType) {
  return typesWithoutLabel.some(function (type) {
    return type === fieldType;
  });
};